import { render, staticRenderFns } from "./AnalyticsPDR.vue?vue&type=template&id=23ba3638&"
import script from "./AnalyticsPDR.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPDR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {
  VContainer,
})
